"use client";

import { cn } from "../../../lib";
import {
	GLASS_BORDER_DEFAULT_BORDER_WIDTH_PX,
	GlassBorder,
	GlassBorderPanel,
	type GlassBorderRadius,
	type GlassBorderTone,
} from "../glass-border";
import {
	PIP_GLASS_SHELL_PLATE_CLASS,
	PIP_GLASS_SHELL_SHELL_BORDER_CLASS,
} from "./pip-glass-shell-styles";

export const PICTURE_IN_PICTURE_GLASS_RADIUS: GlassBorderRadius = "xl";

export interface PictureInPictureGlassShellProps {
	children: React.ReactNode;
	tone?: GlassBorderTone;
	radius?: GlassBorderRadius;
	borderWidth?: number;
	largeBlur?: boolean;
	className?: string;
	wrapperClassName?: string;
	contentClassName?: string;
	plateClassName?: string;
	shellBorderClassName?: string;
}

export function PictureInPictureGlassShell({
	children,
	tone = "system",
	radius = PICTURE_IN_PICTURE_GLASS_RADIUS,
	borderWidth = GLASS_BORDER_DEFAULT_BORDER_WIDTH_PX,
	largeBlur = true,
	className,
	wrapperClassName,
	contentClassName,
	plateClassName = PIP_GLASS_SHELL_PLATE_CLASS,
	shellBorderClassName = PIP_GLASS_SHELL_SHELL_BORDER_CLASS,
}: PictureInPictureGlassShellProps) {
	return (
		<GlassBorder
			variant="inner"
			tone={tone}
			radius={radius}
			borderWidth={borderWidth}
			largeBlur={largeBlur}
			plateClassName={plateClassName}
			shellBorderClassName={shellBorderClassName}
			className={cn("box-border h-full w-full overflow-hidden shadow-lg", className)}
			wrapperClassName={cn(
				"box-border h-full w-full overflow-hidden",
				wrapperClassName,
			)}
			contentClassName={cn(
				"h-full w-full overflow-hidden",
				contentClassName,
			)}
		>
			<GlassBorderPanel className="relative h-full w-full overflow-hidden">
				{children}
			</GlassBorderPanel>
		</GlassBorder>
	);
}
